import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router);

export default new Router({
    // mode: 'history',
    routes: [
      {
        path: "/login",
        name: "login",
        component: () => import("@/views/largeModel/Login"),
        meta: { requiresAuth: false },
      },
      {
        path: "/wx/callback",
        name: "wx_callback",
        component: () => import("@/views/largeModel/WxCallback"),
        meta: { requiresAuth: false },
      },
      {
        path: "/user/wx/callback",
        name: "user_wx_callback",
        component: () => import("@/views/largeModel/WxCallback"),
        meta: { requiresAuth: false },
      },
      {
        path: "/wx/bind",
        name: "wx_bind",
        component: () => import("@/views/largeModel/WxBind"),
        meta: { requiresAuth: false },
      },
      /** 真人素材人像授权（无侧栏菜单，链接可发给用户扫码） */
      {
        path: "/aigc/real-human-liveness",
        name: "lm_real_human_liveness",
        meta: { title: "真人素材认证授权", requiresAuth: false },
        component: () => import("@/views/largeModel/RealHumanLivenessAuth"),
      },
      // 兼容旧/手滑写法：/largeModel -> /large-model
      {
        path: "/largeModel",
        redirect: "/aigc",
      },
      {
        path: "/large-model",
        redirect: "/aigc",
      },
      {
        path: "/aigc",
        name: "large_model",
        component: () => import("@/views/largeModel/Layout"),
        redirect: { name: "lm_home" },
        children: [
          {
            path: "home",
            name: "lm_home",
            component: () => import("@/views/largeModel/Home"),
          },
          {
            path: "create",
            name: "lm_image_create",
            meta: { title: "图片创作", lmHidePageHeader: true, lmDocScroll: true },
            component: () => import("@/views/largeModel/ImageCreate"),
          },
          {
            path: "projects",
            name: "lm_projects",
            meta: { title: "项目管理" },
            component: () => import("@/views/largeModel/Projects"),
          },
          {
            path: "projects/:projectId/episodes",
            name: "lm_project_episodes",
            meta: { title: "分集列表" },
            component: () => import("@/views/largeModel/Episodes"),
          },
          {
            path: "projects/:projectId/episodes/:episodeId",
            name: "lm_episode_detail",
            meta: { title: "分镜列表" },
            component: () => import("@/views/largeModel/EpisodeDetail"),
          },
          {
            path: "projects/:projectId/episodes/:episodeId/script",
            name: "lm_episode_script",
            meta: { title: "剧本创作" },
            component: () => import("@/views/largeModel/EpisodeScript"),
          },
          {
            path: "works",
            name: "lm_works",
            meta: { title: "创作案例" },
            component: () => import("@/views/largeModel/Works"),
          },
          {
            path: "guide",
            name: "lm_guide",
            meta: { title: "制作指引" },
            component: () => import("@/views/largeModel/Guide"),
          },
          {
            path: "recharge",
            name: "lm_recharge",
            meta: { title: "积分充值" },
            component: () => import("@/views/largeModel/PointsRecharge"),
          },
          {
            path: "balance-recharge",
            name: "lm_balance_recharge",
            meta: { title: "余额充值" },
            component: () => import("@/views/largeModel/Recharge"),
          },
          {
            path: "amount-detail",
            name: "lm_amount_detail",
            meta: { title: "账单明细", lmDocScroll: true },
            component: () => import("@/views/largeModel/AmountDetail"),
          },
          // 资产
          {
            path: "assets",
            redirect: { name: "lm_assets_roles" },
          },
          {
            path: "assets/roles",
            name: "lm_assets_roles",
            meta: { title: "角色库" },
            component: () => import("@/views/largeModel/AssetsRolesList"),
          },
          {
            path: "assets/roles/create",
            name: "lm_assets_roles_create",
            meta: { title: "角色" },
            component: () => import("@/views/largeModel/AssetsRoleCreate"),
          },
          {
            path: "assets/roles/:id",
            name: "lm_assets_roles_detail",
            meta: { title: "角色" },
            component: () => import("@/views/largeModel/AssetsRoleCreate"),
          },
          {
            path: "assets/props",
            name: "lm_assets_props",
            meta: { title: "道具库" },
            component: () => import("@/views/largeModel/AssetsPropsList"),
          },
          {
            path: "assets/props/create",
            name: "lm_assets_props_create",
            meta: { title: "道具" },
            component: () => import("@/views/largeModel/AssetsPropCreate"),
          },
          {
            path: "assets/props/:id",
            name: "lm_assets_props_detail",
            meta: { title: "道具" },
            component: () => import("@/views/largeModel/AssetsPropCreate"),
          },
          {
            path: "assets/scenes",
            name: "lm_assets_scenes",
            meta: { title: "场景库" },
            component: () => import("@/views/largeModel/AssetsScenesList"),
          },
          {
            path: "assets/scenes/create",
            name: "lm_assets_scenes_create",
            meta: { title: "场景" },
            component: () => import("@/views/largeModel/AssetsScenesCreate"),
          },
          {
            path: "assets/scenes/:id",
            name: "lm_assets_scenes_detail",
            meta: { title: "场景" },
            component: () => import("@/views/largeModel/AssetsScenesCreate"),
          },
          {
            path: "assets/generate",
            name: "lm_assets_generate",
            meta: { title: "生成库" },
            component: () => import("@/views/largeModel/AssetsGenerateList"),
          },
          {
            path: "assets/favorites",
            name: "lm_assets_favorites",
            meta: { title: "我的收藏" },
            component: () => import("@/views/largeModel/FavoritesList"),
          },
          // 工具库
          {
            path: "tools",
            name: "lm_tools",
            meta: { title: "工具库" },
            component: () => import("@/views/largeModel/ToolsLibrary"),
          },
          {
            path: "tools/super-resolution",
            name: "lm_tools_super_resolution",
            meta: { title: "超分增强" },
            component: () => import("@/views/largeModel/ToolsSuperResolution"),
          },
          {
            path: "tools/subtitle-removal",
            name: "lm_tools_subtitle_removal",
            meta: { title: "字幕擦除" },
            component: () => import("@/views/largeModel/ToolsSubtitleRemoval"),
          },
        ],
      },
      {
        path: '/',
        name: 'home',
        component: () =>
            import ('@/views/home'),
        children: [{
                path: '/overview',
                name: 'overview',
                component: () =>
                    import ('@/views/overview/overview')
            },
            {
                path: '/message',
                name: 'message',
                component: () =>
                    import ('@/views/overview/message')
            },
            {
                path: '/message_detail',
                name: 'message_detail',
                component: () =>
                    import ('@/views/overview/message_detail')
            },

            //instance
            {
                path: '/instances',
                name: 'instances',
                component: () =>
                    import ('@/views/instance/instances')
            },
            {
                path: '/instance_detail',
                name: 'instance_detail',
                component: () =>
                    import ('@/views/instance/instance_detail')
            },
            {
                path: '/instance_updown',
                name: 'instance_updown',
                component: () =>
                    import ('@/views/instance/instance_updown')
            },
            {
                path: '/instance_updown_tencent',
                name: 'instance_updown_tencent',
                component: () =>
                    import ('@/views/instance/instance_updown_tencent')
            },
            {
                path: '/instance_recycle',
                name: 'instance_recycle',
                component: () =>
                    import ('@/views/instance/instance_recycle')
            },
            {
                path: '/security_group',
                name: 'security_group',
                component: () =>
                    import ('@/views/instance/security_group')
            },
            {
                path: '/clouds_mgt',
                name: 'clouds_mgt',
                component: () =>
                    import ('@/views/instance/clouds_mgt')
            },
            {
                path: '/clouds_mgt_info',
                name: 'clouds_mgt_info',
                component: () =>
                    import ('@/views/instance/clouds_mgt_info')
            },
            {
                path: '/clouds_mgt_detail',
                name: 'clouds_mgt_detail',
                component: () =>
                    import ('@/views/instance/clouds_mgt_detail')
            },
            //domain
            {
                path: '/domain_list',
                name: 'domain_list',
                component: () =>
                    import ('@/views/domain/domain_list')
            },
            {
                path: '/domain_detail',
                name: 'domain_detail',
                component: () =>
                    import ('@/views/domain/domain_detail')
            },
            {
                path: '/detail_edit',
                name: 'detail_edit',
                component: () =>
                    import ('@/views/domain/detail_edit')
            },
            {
                path: '/parsing_dns',
                name: 'parsing_dns',
                component: () =>
                    import ('@/views/domain/parsing_dns')
            },
            {
                path: '/domain_renewal',
                name: 'domain_renewal',
                component: () =>
                    import ('@/views/domain/domain_renewal')
            },
            {
                path: '/info_tempList',
                name: 'info_tempList',
                component: () =>
                    import ('@/views/domain/info_tempList')
            },
            {
                path: '/add_temp',
                name: 'add_temp',
                component: () =>
                    import ('@/views/domain/add_temp')
            },
            {
                path: '/info_certification',
                name: 'info_certification',
                component: () =>
                    import ('@/views/domain/info_certification')
            },
            {
                path: '/temp_detail',
                name: 'temp_detail',
                component: () =>
                    import ('@/views/domain/temp_detail')
            },

            //finance
            {
                path: '/recharge',
                name: 'recharge',
                component: () =>
                    import ('@/views/finance/recharge')
            },
            {
                path: '/amount_detail',
                name: 'amount_detail',
                component: () =>
                    import ('@/views/finance/amount_detail')
            },
            {
                path: '/cash',
                name: 'cash',
                component: () =>
                    import ('@/views/finance/cash')
            },
            {
                path: '/buyOrder',
                name: 'buyOrder',
                component: () =>
                    import ('@/views/finance/buyOrder')
            },
            {
                path: '/buyOrder_detail',
                name: 'buyOrder_detail',
                component: () =>
                    import ('@/views/finance/buyOrder_detail')
            },
            {
                path: '/contract',
                name: 'contract',
                component: () =>
                    import ('@/views/finance/contract')
            },
            {
                path: '/contract_apply',
                name: 'contract_apply',
                component: () =>
                    import ('@/views/finance/contract_apply')
            },
            {
                path: '/invoice',
                name: 'invoice',
                component: () =>
                    import ('@/views/finance/invoice')
            },
            {
                path: '/invoice_create',
                name: 'invoice_create',
                component: () =>
                    import ('@/views/finance/invoice_create')
            },
            {
                path: '/invoice_apply',
                name: 'invoice_apply',
                component: () =>
                    import ('@/views/finance/invoice_apply')
            },
            {
                path: '/invoice_detail',
                name: 'invoice_detail',
                component: () =>
                    import ('@/views/finance/invoice_detail')
            },
            {
                path: '/coupon',
                name: 'coupon',
                component: () =>
                    import ('@/views/finance/coupon')
            },
            {
                path: '/advance',
                name: 'advance',
                component: () =>
                    import ('@/views/finance/advance')
            },
            {
                path: '/advanceList',
                name: 'advanceList',
                component: () =>
                    import ('@/views/finance/advanceList')
            },
            {
                path: '/accountList',
                name: 'accountList',
                component: () =>
                    import ('@/views/finance/accountList')
            },
            {
                path: '/subAdvanceList',
                name: 'subAdvanceList',
                component: () =>
                    import ('@/views/finance/subAdvanceList')
            },
            {
                path: '/refund',
                name: 'refund',
                component: () =>
                    import ('@/views/finance/refund')
            },
            {
                path: '/refund_apply',
                name: 'refund_apply',
                component: () =>
                    import ('@/views/finance/refund_apply')
            },
            {
                path: '/refund_detail',
                name: 'refund_detail',
                component: () =>
                    import ('@/views/finance/refund_detail')
            },
            //renew
            {
                path: '/renew_list',
                name: 'renew_list',
                component: () =>
                    import ('@/views/renew/renew_list')
            },
            {
                path: '/renew_eip_list',
                name: 'renew_eip_list',
                component: () =>
                    import ('@/views/renew/renew_eip_list')
            },
            //renew
            {
                path: '/renew_rds_list',
                name: 'renew_rds_list',
                component: () =>
                    import ('@/views/renew/renew_rds_list')
            },
            {
                path: '/renew_slb_list',
                name: 'renew_slb_list',
                component: () =>
                    import ('@/views/renew/renew_slb_list')
            },
            //order
            {
                path: '/my_order',
                name: 'my_order',
                component: () =>
                    import ('@/views/order/my_order')
            },
            {
                path: '/order_detail',
                name: 'order_detail',
                component: () =>
                    import ('@/views/order/order_detail')
            },
            {
                path: '/order_score',
                name: 'order_score',
                component: () =>
                    import ('@/views/order/order_score')
            },
            {
                path: '/order_complaint',
                name: 'order_complaint',
                component: () =>
                    import ('@/views/order/order_complaint')
            },
            {
                path: '/order_class',
                name: 'order_class',
                component: () =>
                    import ('@/views/order/order_class')
            },
            {
                path: '/order_form',
                name: 'order_form',
                component: () =>
                    import ('@/views/order/order_form')
            },
            //setting
            {
                path: '/security',
                name: 'security',
                component: () =>
                    import ('@/views/setting/security')
            },
            {
                path: '/edit_qq',
                name: 'edit_qq',
                component: () =>
                    import ('@/views/setting/edit_qq')
            },
            {
                path: '/certification',
                name: 'certification',
                component: () =>
                    import ('@/views/setting/certification')
            },
            {
                path: '/comoany_certification',
                name: 'comoany_certification',
                component: () =>
                    import ('@/views/setting/comoany_certification')
            },
            {
                path: '/password',
                name: 'password',
                component: () =>
                    import ('@/views/setting/password')
            },
            {
                path: '/edit_mobile',
                name: 'edit_mobile',
                component: () =>
                    import ('@/views/setting/edit_mobile')
            },
            {
                path: '/email',
                name: 'email',
                component: () =>
                    import ('@/views/setting/email')
            },
            {
                path: '/security_question',
                name: 'security_question',
                component: () =>
                    import ('@/views/setting/security_question')
            },
            {
                path: '/address',
                name: 'address',
                component: () =>
                    import ('@/views/setting/address')
            },
            // 渠道商
            {
                path: '/distributor_synopsis',
                name: 'distributor_synopsis',
                component: () =>
                    import ('@/views/distributor/synopsis')
            },
            {
                path: '/distributor_client_manage',
                name: 'distributor_client_manage',
                component: () =>
                    import ('@/views/distributor/client_manage')
            },
            {
                path: '/distributor_client_detail',
                name: 'distributor_client_detail',
                component: () =>
                    import ('@/views/distributor/client_detail')
            },
            {
                path: '/distributor_client_order',
                name: 'distributor_client_order',
                component: () =>
                    import ('@/views/distributor/client_order')
            },
            {
                path: '/distributor_client_order_detail',
                name: 'distributor_client_order_detail',
                component: () =>
                    import ('@/views/distributor/client_order_detail')
            },
            {
                path: '/distributor_client_assign',
                name: 'distributor_client_assign',
                component: () =>
                    import ('@/views/distributor/client_assign')
            },
            {
                path: '/distributor_invoice',
                name: 'distributor_invoice',
                component: () =>
                    import ('@/views/distributor/invoice')
            },
            {
                path: '/distributor_invoice_apply',
                name: 'distributor_invoice_apply',
                component: () =>
                    import ('@/views/distributor/invoice_apply')
            },
            {
                path: '/distributor_invoice_create',
                name: 'distributor_invoice_create',
                component: () =>
                    import ('@/views/distributor/invoice_create')
            },
            {
                path: '/distributor_invoice_detail',
                name: 'distributor_invoice_detail',
                component: () =>
                    import ('@/views/distributor/invoice_detail')
            },
            {
                path: '/distributor_commission',
                name: 'distributor_commission',
                component: () =>
                    import ('@/views/distributor/commission')
            },
            {
                path: '/distributor_member',
                name: 'distributor_member',
                component: () =>
                    import ('@/views/distributor/member')
            },
            // 常见问题
            {
                path: '/question',
                name: 'question',
                component: () =>
                    import ('@/views/question/question')
            },
            // 常见问题
            {
                path: '/404',
                name: '404',
                component: () =>
                    import ('@/404')
            },
			// 弹性公网IP
			{
			    path: '/eip_list',
			    name: 'eip_list',
			    component: () =>
			        import ('@/views/eip/eip_list')
			},
			// 弹性公网IP
			{
			    path: '/tag_list',
			    name: 'tag_list',
			    component: () =>
			        import ('@/views/instance/tag_list')
			},
			// 云数据库
			{
			    path: '/rds_list',
			    name: 'rds_list',
			    component: () =>
			        import ('@/views/rds/rds_list')
			},
			// 云数据库（回收站）
			{
			    path: '/rds_instance_recycle',
			    name: 'rds_instance_recycle',
			    component: () =>
			        import ('@/views/rds/rds_instance_recycle')
			},
			// 云数据库（基本信息）
			{
			    path: '/rds_basic_info',
			    name: 'rds_basic_info',
			    component: () =>
			        import ('@/views/rds/rds_basic_info')
			},
			// 云数据库（账号管理）
			{
			    path: '/rds_account_manage',
			    name: 'rds_account_manage',
			    component: () =>
			        import ('@/views/rds/rds_account_manage')
			},
			// 云数据库（数据库管理）
			{
			    path: '/rds_manage',
			    name: 'rds_manage',
			    component: () =>
			        import ('@/views/rds/rds_manage')
			},
			// 云数据库（白名单）
			{
			    path: '/rds_white_list',
			    name: 'rds_white_list',
			    component: () =>
			        import ('@/views/rds/rds_white_list')
			},
			// 云数据库（数据备份）
			{
			    path: '/rds_backup',
			    name: 'rds_backup',
			    component: () =>
			        import ('@/views/rds/rds_backup')
			},
			// 云数据库（参数设置）
			{
			    path: '/rds_param_setting',
			    name: 'rds_param_setting',
			    component: () =>
			        import ('@/views/rds/rds_param_setting')
			},
			// 云数据库（日志管理）
			{
			    path: '/rds_log',
			    name: 'rds_log',
			    component: () =>
			        import ('@/views/rds/rds_log')
			},
			// 云数据库（备份设置）
			{
			    path: '/rds_backup_setting',
			    name: 'rds_backup_setting',
			    component: () =>
			        import ('@/views/rds/rds_backup_setting')
			},
			// 云数据库（白名单修改）
			{
			    path: '/rds_white_edit',
			    name: 'rds_white_edit',
			    component: () =>
			        import ('@/views/rds/rds_white_edit')
			},
			// 云数据库（升级降配）
			{
			    path: '/rds_updown',
			    name: 'rds_updown',
			    component: () =>
			        import ('@/views/rds/rds_updown')
			},
			// 云数据库（创建账号）
			{
			    path: '/rds_account_create',
			    name: 'rds_account_create',
			    component: () =>
			        import ('@/views/rds/rds_account_create')
			},
			// 云数据库（创建数据库）
			{
			    path: '/rds_manage_create',
			    name: 'rds_manage_create',
			    component: () =>
			        import ('@/views/rds/rds_manage_create')
			},
			// 云数据库（数据统计）
			{
			    path: '/rds_monitor',
			    name: 'rds_monitor',
			    component: () =>
			        import ('@/views/rds/rds_monitor')
			},
			// 负载均衡
			{
			    path: '/slb_list',
			    name: 'slb_list',
			    component: () =>
			        import ('@/views/slb/slb_list')
			},
			// 负载均衡（证书管理）
			{
			    path: '/certificate_list',
			    name: 'certificate_list',
			    component: () =>
			        import ('@/views/slb/certificate_list')
			},
            // 负载均衡（安全组管理）
			{
			    path: '/slb_sg',
			    name: 'sg',
			    component: () =>
			        import ('@/views/slb/security_group')
			},
			// 负载均衡（管理）
			{
			    path: '/slb_detail',
			    name: 'slb_detail',
			    component: () =>
			        import ('@/views/slb/slb_detail')
			},
			// 负载均衡（升级降配）
			{
			    path: '/slb_updown',
			    name: 'slb_updown',
			    component: () =>
			        import ('@/views/slb/slb_updown')
			},
			// 负载均衡（回收站）
			{
			    path: '/slb_recycle',
			    name: 'slb_recycle',
			    component: () =>
			        import ('@/views/slb/slb_recycle')
			},
      // AI
      {
          path: '/ai_index',
          name: 'ai_index',
          component: () =>
              import ('@/views/ai/ai_index')
      },
			// 短信
			{
			    path: '/sms',
			    name: 'sms',
			    component: () =>
			        import ('@/views/sms/sms')
			},
      {
          path: '/user_access',
          name: 'user_access',
          component: () =>
              import ('@/views/huaweiCloud/user_access')
      },
      {
          path: '/user_certification',
          name: 'user_certification',
          component: () =>
              import ('@/views/huaweiCloud/user_certification')
      },
      {
          path: '/user_certification_rel',
          name: 'user_certification_rel',
          component: () =>
              import ('@/views/huaweiCloud/user_certification_rel')
      },

        ]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js